import React from "react";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import MetaverseEvents from "../../../Utils/Assets/Images/MetaverseEvents.png";
import Explore from "../../../Utils/Assets/Images/Explore.png";
import aboutPhase2 from "../../../Utils/Assets/Images/aboutPhase2.png";

const EarningJourney = () => {
    return (
        <div className={styles.container}>
            <div className={styles.bg}></div>
            <MeetUsWrapper>
                <div className="">
                    <div
                        className={styles.FlexCentrt}
                        data-aos="fade-left"
                        data-aos-duration="800"
                        data-aos-once="false"
                    >
                        <h1>Your Path to Earning MVR Coins</h1>
                    </div>

                    <div className={styles.Grid}>
                        <div
                            data-aos="fade-right"
                            data-aos-duration="800"
                            data-aos-once="false"
                            className={styles.Card1}
                        >
                            <div className={styles.CardTitle}>
                                <h1>Time Spent</h1>
                                <p>
                                    Earn coins for chatting, playing games, or
                                    hosting events.
                                </p>
                            </div>
                            <div className={styles.CardImage}>
                                <img src={aboutPhase2} alt="About Phase 2" />
                            </div>
                        </div>
                        <div
                            data-aos="fade-up"
                            data-aos-duration="800"
                            data-aos-once="false"
                            className={styles.Card2}
                        >
                            <div className={styles.CardTitle}>
                                <h1>Sharing Products</h1>
                                <p>
                                    Promote products and earn bonuses from sharing.
                                </p>
                            </div>
                            <div className={styles.CardImage}>
                                <img src={Explore} alt="Explore" />
                            </div>
                        </div>
                        <div
                            data-aos="fade-left"
                            data-aos-duration="800"
                            data-aos-once="false"
                            className={styles.Card3}
                        >
                            <div className={styles.CardTitle}>
                                <h1>Hosting Events</h1>
                                <p>
                                    Get rewarded for organizing virtual events.
                                </p>
                            </div>
                            <div className={styles.CardImage}>
                                <img src={MetaverseEvents} alt="Metaverse Events" />
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default EarningJourney;
